// src/components/StudentRoute.jsx
//
// Route guard for the student-only /my-checkout page.
//
// Behavior:
//   - Not signed in → redirect to /login
//   - Resolving role (fresh login lookup in progress) → render nothing
//   - Signed in as student → render the children
//   - Signed in as faculty/superadmin → redirect to / (home)

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const StudentRoute = ({ children }) => {
  const { user, loading, roleResolving, isStudent, isSuperAdmin } = useAuth();

  if (loading || roleResolving) {
    return (
      <div
        style={{
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
          fontStyle: 'italic',
        }}
      >
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // SuperAdmin or faculty hitting /my-checkout: send them to home.
  if (!isStudent || isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default StudentRoute;